import { getUrlForQueryParams, replaceString } from '../strings';
import {
  type GET_NETWORK_CONFIG,
  type GET_NETWORK_CONFIG_OPTION,
  type NETWORK_CONFIG,
  type NETWORK_CONFIG_OPTION
} from './type';
import { COMMON_HEADERS, TOKEN_KEY, TRACE_ID } from './constants';
import { v4 as uuidv4 } from 'uuid';

/**
 * concating headers with new Headers
 * */
export const concatHeaders = (
  options: NETWORK_CONFIG_OPTION | GET_NETWORK_CONFIG_OPTION,
  newHeaders: object = {}
) => {
  if (options.headers !== undefined) {
    return {
      ...options,
      headers: {
        ...options.headers,
        ...newHeaders
      }
    };
  }

  return { ...options, headers: { ...newHeaders } };
};

/**
 * TO DO: handle authorization here for Webview as well
 * */
export const concatAuthorizationHeader = (
  options: NETWORK_CONFIG_OPTION | GET_NETWORK_CONFIG_OPTION
) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token !== null) {
    return concatHeaders(options, { Authorization: `Bearer ${token}` });
  }

  return options;
};

/**
 * updating param value in URL
 * */
export const updateParamsInConfig = (
  config: NETWORK_CONFIG | GET_NETWORK_CONFIG,
  key: string,
  value: string
): NETWORK_CONFIG | GET_NETWORK_CONFIG => {
  return {
    ...config,
    url: replaceString(config.url, key, value)
  };
};

/**
 * appending query params in URL
 */
export const appendQueryParamsInConfig = (
  config: NETWORK_CONFIG | GET_NETWORK_CONFIG,
  values: object = {}
) => {
  return {
    ...config,
    url: getUrlForQueryParams(config.url, values)
  };
};

export const parseJSON = async (response: any) => {
  const json = await response.json();
  return json;
};

export const getUUID = () => {
  return uuidv4();
};

export const getTraceId = () => {
  return `BFFTraceId@${getUUID()}`;
};

export const getCommonHeaders = () => {
  return {
    ...COMMON_HEADERS,
    [TRACE_ID]: getTraceId()
  };
};
